<template>
    <div class="container">
        <div class="wrapper">
            <div class="main">
                <div class="header">
                    <div>
                        <h1>IMTS Community Events</h1>
                    </div>
                    <div>
                        <a href="https://calendar.google.com/calendar/embed?src=c_b1f62881018817eee5d5f1cfb7fba7028be28c3e4f0ac895dfc0fb15eff6b631%40group.calendar.google.com&ctz=America%2FChicago" target="_blank">Google Calendar</a>
                        <a href="https://f6idcwsxdyk.typeform.com/to/K7yXXUDJ" target="_blank">Submit an Event</a>
                        <p>All times in CT</p>
                    </div>
                </div>
                <div class="loader" v-if="!jsonData">
                    <FontAwesomeIcon icon="circle-notch" spin />
                </div>
                <div v-for="(day, index) in eventsByDay" :key="index" style="display:flex;flex-direction: column; gap:8px; margin:8px 0px;">
                    <p>{{ day.name }}</p>
                    <EventCard v-for="(event, index) in day.events" :key="index" :event="event" />
                </div>
            </div>
            <div class="footer"><img @click="goToUrl('https://chatter.dev/')" src='/img/PoweredByChatter-100.png' /></div>
        </div>
    </div>
</template>
  
<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'

library.add(faCircleNotch)

import EventCard from './EventCard.vue';
    export default {
        name: 'EventsPage',
        components: {
            EventCard,
            FontAwesomeIcon,
        },
        data() {
            return {
                jsonData: null,
             };
        },
        created() {
            fetch('https://api2.chatter.dev/imts/calendar')
                .then(response => response.json())
                .then(data => {
                this.jsonData = data.data;
                })
                .catch(error => {
                console.error('Error fetching data:', error);
                });
        },
        methods: {
            toTimeString(datetimeString) {
                const date = new Date(datetimeString);
                const options = {
                    timeZone: 'America/Chicago',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true
                };
                return date.toLocaleString('en-US', options);
            },
            goToUrl(url) {
                window.open(url, '_blank');
            },
        },
        computed: {
            eventsByDay() {
                if (!this.jsonData) return [];
                const eventsByDay = {};
                this.jsonData.forEach(event => {
                const date = new Date(event.start);
                const day = date.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
                if (!eventsByDay[day]) {
                    eventsByDay[day] = [];
                }
                eventsByDay[day].push({
                    name: event.name,
                    start: event.start,
                    location: event.location,
                    eventLink: event.eventLink,
                    infoLink: event.infoLink,
                    description: event.description,
                    image: event.image,
                });
                });
                // Sort events by start time
                Object.values(eventsByDay).forEach(events => {
                    events.sort((a, b) => new Date(a.start) - new Date(b.start));
                });

                return Object.entries(eventsByDay).map(([name, events]) => ({ name, events }));
            }
        }
    };
</script>
  
<style scoped>
  /* Add any styles if needed */
</style>
  